import { Phone, MessageSquare } from "lucide-react";
import { CONTACT } from "@/data";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const StickyBar = () => {
  return (
    <div
      data-testid="sticky-contact-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 border-t border-white/10 bg-[#1c1c20]/95 backdrop-blur-xl"
    >
      <a
        data-testid="sticky-call-button"
        href={`tel:${CONTACT.phoneRaw}`}
        className="flex items-center justify-center gap-2 py-4 font-bold text-white bg-[#E63946]"
      >
        <Phone className="w-5 h-5" /> Call Now
      </a>
      <button
        data-testid="sticky-quote-button"
        onClick={() => scrollTo("contact")}
        className="flex items-center justify-center gap-2 py-4 font-bold text-white"
      >
        <MessageSquare className="w-5 h-5 text-[#E63946]" /> Free Quote
      </button>
    </div>
  );
};
